import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { PointCardEditTemplate } from 'components/Templates'

const PointCardEdit: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isEdit = /^\/point_card\/(?!create$)[^/]+$/.test(pathname)
  const pointCardId = isEdit ? pathname.split('/point_card/')[1] : undefined

  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'ポイントカード'} title={'ポイントカード'}>
      <PointCardEditTemplate isEdit={isEdit} pointCardId={pointCardId} />
    </Layout>
  )
}

export default PointCardEdit
